import {
  Component,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';

import { PosPrintPage } from 'src/app/pages/pos-print/pos-print.page';
import { DataService } from 'src/app/services/data.service';

import { ModalController } from '@ionic/angular';

import { OrderDetailComponent } from '../order-detail/order-detail.component';

@Component({
  selector: 'app-cus-orders',
  templateUrl: './cus-orders.component.html',
  styleUrls: ['./cus-orders.component.scss'],
})
export class CusOrdersComponent implements OnInit {

//  @Output() orders_details;

is_order = false;
constructor(public db:DataService,public modalCtrl:ModalController,private router:Router) { }

  ngOnInit() {
    this.is_order = false;
      setTimeout( () => {  
        if(this.db.allOrders && this.db.allOrders.length == 0)
          this.is_order = true
      },4000);
    // this.db.Wallet_points = false;
  }

    async printOrder(printList) {
    printList.items = printList.Items
    const modal = await this.modalCtrl.create({
    component: PosPrintPage,
    cssClass: 'my-custom-class-modaal',
    componentProps: {
      bill_details:printList,product_info:printList,is_order:0 
    }
  });
  return await modal.present();
  }
 
  showOrders(item){
    this.router.navigate(['/order'+'/'+item.name]);
  }
  // order_click(item){

  // }

  async order_click(item) {
    // console.log("Items",item)
    this.db.modal_popup = true;
    let modal = await this.modalCtrl.create({
      component: OrderDetailComponent,
      cssClass: "Orders_detail",
      componentProps: {
        items : item
      },
    });
    await modal.present();
    let data = await modal.onWillDismiss();
  }

}
